import { render } from "./AppDropdownItem.vue?vue&type=template&id=7a41d354"
import script from "./AppDropdownItem.vue?vue&type=script&lang=js"
export * from "./AppDropdownItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__